module.exports = __webpack_public_path__ + "static/payments_svg-c089410c5b826ccc0e78fc05e7bbb400.svg";